function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Paginator } from '@domain-group/fe-blueprint-ui/pagination';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { BtrInfoMessage } from '@domain-group/fe-co-allhomes-shared-components';
import { withEventBoundary } from '@domain-group/fe-co-analytics';
import insertFluidAds from '../../utils/insert-fluid-ads';
import AllhomesListingNoSearchResults from '../allhomes-listing-no-search-results';
import * as styles from './allhomes-listing-list-search-results.style';
import { CrossPromotion } from '../cross-promotion/cross-promotion';
import { WrappedListingCard } from '../wrapped-listing-card';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ListSearchResults = _ref => {
  var searchQuery = _ref.searchQuery,
    firstSearch = _ref.firstSearch,
    _ref$searchResults = _ref.searchResults,
    searchResults = _ref$searchResults === void 0 ? [] : _ref$searchResults,
    _ref$inlineAdsDisable = _ref.inlineAdsDisabled,
    inlineAdsDisabled = _ref$inlineAdsDisable === void 0 ? false : _ref$inlineAdsDisable,
    _ref$isDefaultSearch = _ref.isDefaultSearch,
    isDefaultSearch = _ref$isDefaultSearch === void 0 ? false : _ref$isDefaultSearch,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? 1 : _ref$totalPages,
    _ref$featuredProperti = _ref.featuredProperties,
    featuredProperties = _ref$featuredProperti === void 0 ? [] : _ref$featuredProperti,
    _ref$propertiesOfTheW = _ref.propertiesOfTheWeek,
    propertiesOfTheWeek = _ref$propertiesOfTheW === void 0 ? [] : _ref$propertiesOfTheW,
    media = _ref.media,
    _ref$onAddToWatchlist = _ref.onAddToWatchlist,
    onAddToWatchlist = _ref$onAddToWatchlist === void 0 ? () => {} : _ref$onAddToWatchlist,
    _ref$onClearFilter = _ref.onClearFilter,
    onClearFilter = _ref$onClearFilter === void 0 ? () => {} : _ref$onClearFilter,
    _ref$onPropertyAlertC = _ref.onPropertyAlertClick,
    onPropertyAlertClick = _ref$onPropertyAlertC === void 0 ? () => {} : _ref$onPropertyAlertC,
    _ref$onIncludeSurroun = _ref.onIncludeSurroundingSuburbs,
    onIncludeSurroundingSuburbs = _ref$onIncludeSurroun === void 0 ? () => {} : _ref$onIncludeSurroun,
    _ref$onPageChange = _ref.onPageChange,
    onPageChange = _ref$onPageChange === void 0 ? () => {} : _ref$onPageChange,
    paginatorUrlTemplate = _ref.paginatorUrlTemplate,
    propertyAlertProps = _ref.propertyAlertProps,
    crossPromotion = _ref.crossPromotion;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl,
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var mobile = media.mobile;
  var noResults = isEmpty(searchResults);
  var enableCrossPromotion = toggledFeatures && toggledFeatures[ToggledFeatureKey.CROSS_PROMOTION];
  var hasBTR = Boolean(searchResults.find(result => {
    var _result$development;
    return (result === null || result === void 0 ? void 0 : (_result$development = result.development) === null || _result$development === void 0 ? void 0 : _result$development.type) === 'RENTAL';
  }));
  var showFluidAds = mobile && !inlineAdsDisabled;
  var listingList = searchResults.map(result => ___EmotionJSX("div", {
    css: styles.row(),
    key: "listing-".concat(result.listing.id)
  }, ___EmotionJSX(WrappedListingCard, _extends({
    appearance: mobile ? 'vertical' : 'horizontal',
    css: styles.item,
    onAddToWatchlist: onAddToWatchlist
  }, result))));
  return ___EmotionJSX("div", {
    css: styles.searchContent({
      hasNoResult: noResults,
      hasSingleFeaturedProperty: mobile && featuredProperties.length === 1
    })
  }, !noResults && ___EmotionJSX("div", {
    css: styles.items({
      hasSingleFeaturedProperty: mobile && featuredProperties.length === 1
    })
  }, hasBTR && ___EmotionJSX("div", {
    css: styles.btrInfo
  }, ___EmotionJSX(BtrInfoMessage, {
    variant: "search-result"
  })), showFluidAds ? insertFluidAds(listingList, {
    adRowStyle: styles.row({
      isAd: true,
      isFluid: true
    })
  }) : listingList), enableCrossPromotion && ___EmotionJSX(CrossPromotion, {
    searchQuery: searchQuery,
    firstSearch: firstSearch,
    searchResults: searchResults,
    propertyAlertProps: propertyAlertProps,
    onIncludeSurroundingSuburbs: onIncludeSurroundingSuburbs,
    options: crossPromotion !== null && crossPromotion !== void 0 ? crossPromotion : {
      attempts: [],
      similarProperties: []
    }
  }), !enableCrossPromotion && noResults && ___EmotionJSX(AllhomesListingNoSearchResults, {
    isDefaultSearch: isDefaultSearch,
    propertiesOfTheWeek: isEmpty(featuredProperties) ? propertiesOfTheWeek : [],
    onClearFilter: onClearFilter,
    onPropertyAlertClick: onPropertyAlertClick
  }), totalPages > 1 && ___EmotionJSX(Paginator, {
    currentPage: currentPage,
    totalPages: totalPages,
    urlTemplate: getAbsoluteUrl === null || getAbsoluteUrl === void 0 ? void 0 : getAbsoluteUrl(paginatorUrlTemplate),
    onPageChange: onPageChange
  }));
};
export default withEventBoundary({
  data: {
    pageSection: 'search-results'
  }
})(ListSearchResults);